// src/i18n/I18nContext.js
import React, { createContext, useContext, useMemo, useState, useEffect } from "react";
import strings from "./strings";

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  // idioma padrão: tenta pegar do localStorage, senão pt-BR
  const [language, setLanguage] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = window.localStorage.getItem("editor-language");
      if (stored && (stored === "en" || stored === "pt")) return stored;
    }
    return "pt"; // default: PT-BR
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("editor-language", language);
    }
  }, [language]);

  const value = useMemo(() => {
    const t = (key) => {
      const langStrings = strings[language] || strings.pt;
      // fallback ordem: idioma atual → pt → en → key
      return (
        (langStrings && langStrings[key]) ||
        (strings.pt && strings.pt[key]) ||
        (strings.en && strings.en[key]) ||
        key
      );
    };

    return { language, setLanguage, t };
  }, [language]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error("useI18n must be used within an I18nProvider");
  }
  return ctx;
};
